// Project and file types for the IDE

export interface FileNode {
  id: string;
  name: string;
  type: 'file' | 'folder';
  path: string;
  extension?: string;
  children?: FileNode[];
  content?: string;
  isOpen?: boolean;
  locked?: boolean;
}

export interface Project {
  id: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  files: FileNode[];
  activeFileId?: string;
}

export interface EditorTab {
  id: string;
  fileId: string;
  fileName: string;
  filePath: string;
  language: string;
  isDirty: boolean;
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant' | 'system';
  content: string;
  timestamp: Date;
}

export interface ChatSession {
  id: string;
  name: string;
  messages: ChatMessage[];
  createdAt: Date;
}

// Language detection helper
export function getLanguageFromExtension(extension: string): string {
  const languageMap: Record<string, string> = {
    sol: 'solidity',
    js: 'javascript',
    ts: 'typescript',
    jsx: 'javascript',
    tsx: 'typescript',
    json: 'json',
    md: 'markdown',
    txt: 'plaintext',
    yml: 'yaml',
    yaml: 'yaml',
  };
  return languageMap[extension] || 'plaintext';
}

// Get file icon based on extension
export function getFileIcon(extension?: string): string {
  const iconMap: Record<string, string> = {
    sol: '◆',
    js: '⬡',
    ts: '◇',
    json: '{ }',
    md: '📄',
    txt: '📝',
  };
  return iconMap[extension || ''] || '📄';
}